"use strict";

/*@ngInject*/
module.exports = function headerController() {
    var vm = this;
};


/** WEBPACK FOOTER **
 ** ./app/shared/controllers/header.controller.js
 **/